// extracted by mini-css-extract-plugin
export default {"wrapper":"ReytingComponent_wrapper__KATUw","empty_active":"ReytingComponent_empty_active__SoRRo","empty":"ReytingComponent_empty__Zu7ld"};